module.exports = __webpack_public_path__ + "images/dacia_smallcf49b3d321e6bb14fed39c80af70e4b9.png";